import React, { useState } from 'react';
import SharedFlatpickr from "@shared/flatpickr"
import Checkbox from '@shared/checkbox/checkbox';

const ReceiveGoodsForm = ({ purchaseOrder, purchaseLines: initialPurchaseLines, backRoute }) => {
  const [purchaseLines, setPurchaseLines]       = useState(initialPurchaseLines);
  const [filter, setFilter]                     = useState('');
  const [hideDelivered, setHideDelivered]       = useState(false);
  const allowSearch                             = purchaseLines.length > 5;

  const handlePrefillQuantity = () => {
    const updatedLines = purchaseLines.map(line => {
      // Prefill quantity only for filtered lines
      if (line.displayReception.toLowerCase().includes(filter.toLowerCase())) {
        return { ...line, quantityReceivedNow: line.quantityComing };
      }
      return line;
    });
    setPurchaseLines(updatedLines);
  };

  const handleQuantityChange = (e, lineId) => {
    const updatedLines = purchaseLines.map(line =>
      line.id === lineId ? { ...line, quantityReceivedNow: e.target.value } : line
    );
    setPurchaseLines(updatedLines);
  };

  const handleFullyDeliveredChange = (checked, lineId) => {
    const updatedLines = purchaseLines.map(line => {
      if (line.id === lineId) {
        return {
          ...line,
          quantityReceivedNow: checked ? line.quantityComing : '',
          fullyDelivered: checked
        };
      }
      return line;
    });
    setPurchaseLines(updatedLines);
  };

  const handleHideDeliveredChange = () => (checked) => {
    setHideDelivered(checked);
  };

  return (
    <div>
      <div className="purchase-reception-head">
        <h3>{I18n.t('purchase_orders.reception.title_modal', { number: purchaseOrder.number })}</h3>
        {purchaseOrder.title && <div className="purchase-reception-head__subtitle">{purchaseOrder.title}</div>}
      </div>

      <div className="purchase-reception-summary">
        {[
          ['header_supplier',    purchaseOrder.supplier],
          ['header_destination', purchaseOrder.destination],
          ['header_ordered_on',  purchaseOrder.creationDate],
          ['header_expected_on', purchaseOrder.expectedDeliveryDate]
        ].map(([key, value]) => (
          <div key={key} className="purchase-reception-summary__item">
            <div className="purchase-reception-summary__label">{I18n.t(`purchase_orders.reception.${key}`)}</div>
            <div className="purchase-reception-summary__value" title={value || ''}>{value || '—'}</div>
          </div>
        ))}

        {/* Reception date */}
        <div className="purchase-reception-summary__item purchase-reception-summary__item--input">
          <label className="purchase-reception-summary__label" htmlFor="reception_date">
            {I18n.t('purchase_orders.reception.header_received_on')}
          </label>
          <SharedFlatpickr
            id        = "reception_date"
            className = "form-control flatpickr-nobg"
            value     = {new Date().toLocaleDateString('fr-FR')}
            options   = {{
              dateFormat: "d/m/Y",
              locale: I18n.locale,
              mode: 'single'
            }}
            name="reception_date"
            required
          />
        </div>
      </div>

      {/* Search Filter */}
      {allowSearch && (
        <div className="mb-3">
          <input
            type="text"
            placeholder={I18n.t('purchase_orders.reception.search_placeholder')}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="form-control"
          />
        </div>
      )}

      <div style={{ height: '42vh', overflowY: 'scroll' }}>
        <div className="purchase-reception-grid mb-3">
          <div className="purchase-reception-grid__header">
            <div>{I18n.t('purchase_orders.reception.description')}</div>
            <div className="text-right pr-2">{I18n.t('purchase_orders.reception.quantity_ordered')}</div>
            <div className="text-right pr-2">{I18n.t('purchase_orders.reception.quantity_already_received')}</div>
            <div className="text-right pr-2">{I18n.t('purchase_orders.reception.quantity_coming')}</div>
            <div className="text-center">{I18n.t('purchase_orders.reception.quantity_received_now')}</div>
            <div>&nbsp;</div>
          </div>

          {/* Purchase Lines List */}
          {purchaseLines
            .filter(line => {
              // filter those matching the search term
              return line.displayReception.toLowerCase().includes(filter.toLowerCase()) &&
              // and hide fully delivered if checkbox unchecked
              (!hideDelivered || line.quantityComing > 0)
            })
            .map(line => (
              <div key={line.id} className="d-contents">
                <input
                  type="hidden"
                  name={`purchase_order[purchase_lines_attributes][${line.id}][id]`}
                  value={line.id}
                />

                <div>
                  {line.displayReception}
                </div>

                <div className="text-right pr-2">
                  {line.quantityOrdered}
                </div>

                <div className="text-right pr-2">
                  {line.quantityAlreadyReceived}
                </div>

                <div className="text-right pr-2">
                  {line.quantityComing}
                </div>

                <div className="text-right">
                  {!line.hasSerialNumbers && (
                    <input
                      type="number"
                      name={`purchase_order[purchase_lines_attributes][${line.id}][quantity_received_now]`}
                      step="0.01"
                      min="0"
                      value={line.quantityReceivedNow || ''}
                      onChange={(e) => handleQuantityChange(e, line.id)}
                      className="form-control text-right quantity-received-now"
                    />
                  )}
                </div>

                <div className="text-center">
                  <Checkbox
                    id        = {`${line.id}_fullyDelivered`}
                    checked   = {line.fullyDelivered}
                    className = 'pl-2 mb-0'
                    onChange  = {(e) => handleFullyDeliveredChange(e, line.id)}
                  />
                </div>

                {/* Handle Products with Serial Numbers: the serial fields show up once the line is ticked as received */}
                {line.hasSerialNumbers && (line.serialNumbers.length > 0 || (line.fullyDelivered && line.quantityComing > 0)) && (
                  <div className="d-contents">
                    <div></div>
                    <div className="g-c-span-5">
                      {line.serialNumbers.map((receivedSerial, i) => (
                        <input
                          key={i}
                          type="text"
                          value={receivedSerial}
                          className="form-control mb-1"
                          disabled
                        />
                      ))}

                      {line.fullyDelivered && line.serialized && line.quantityComing > 0 && (
                        <div className="purchase-reception-serial-row purchase-reception-serial-row--head">
                          <span>{I18n.t('products.serial_number')}</span>
                          <span>{I18n.t('serialized_materials.table.calibration_due_on')}</span>
                          <span>{I18n.t('serialized_materials.table.expires_on')}</span>
                        </div>
                      )}
                      {line.fullyDelivered && [...Array(line.quantityComing)].map((_, i) => (
                        <div key={i} className={line.serialized ? 'purchase-reception-serial-row' : ''}>
                          <input
                            type="text"
                            name={`purchase_order[purchase_lines_attributes][${line.id}][serials_received_now][]`}
                            placeholder={I18n.t('products.serial_number')}
                            className="form-control mb-1"
                            autoFocus={i === 0}
                          />
                                                    {line.serialized && ['calibrations_received_now', 'expirations_received_now'].map(field => (
                            <SharedFlatpickr
                              key         = {field}
                              className   = "form-control flatpickr-nobg mb-1"
                              placeholder = {I18n.t(field === 'calibrations_received_now' ? 'serialized_materials.table.calibration_due_on' : 'serialized_materials.table.expires_on')}
                              options     = {{ dateFormat: "d/m/Y", locale: I18n.locale, mode: 'single', allowInput: true }}
                              name        = {`purchase_order[purchase_lines_attributes][${line.id}][${field}][]`}
                            />
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>

      <div className="d-grid g-t-col-12 mt-3">
        <div className="d-contents">
          {/* Include items already fully delivered */}
          <div className="g-c-span-6">
            <Checkbox
              name      = 'hideDelivered'
              checked   = {hideDelivered}
              id        = {'hideDelivered'}
              onChange  = {handleHideDeliveredChange()}
              label     = {I18n.t("purchase_orders.reception.hide_delivered")}
              className = "form-group"
            />
          </div>

          {/* Prefill Quantity Button */}
          <div className="g-c-span-6 text-right" style={{ alignSelf: 'start' }}>
            <a href="#"
              onClick={(e) => {
                e.preventDefault();
                handlePrefillQuantity();
              }}
            >
              <i className="fas fa-plus-circle mr-1"></i>
              {I18n.t('purchase_orders.reception.prefill_quantity')}
            </a>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ReceiveGoodsForm;
